import { render, staticRenderFns } from "./monitor-details.vue?vue&type=template&id=00b2822f"
import script from "./monitor-details.vue?vue&type=script&lang=ts"
export * from "./monitor-details.vue?vue&type=script&lang=ts"
import style0 from "./monitor-details.vue?vue&type=style&index=0&id=00b2822f&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b2822f')) {
      api.createRecord('00b2822f', component.options)
    } else {
      api.reload('00b2822f', component.options)
    }
    module.hot.accept("./monitor-details.vue?vue&type=template&id=00b2822f", function () {
      api.rerender('00b2822f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitor-details/monitor-details.vue"
export default component.exports